module.exports = __webpack_public_path__ + "static/media/kindle.cb8c86b1.svg";